import {
    SHOPCRATE_LANGUAGE
} from "../ShopCrateLocalization";

function PriceFormatter({ price }) {
    return new Intl.NumberFormat(SHOPCRATE_LANGUAGE, { style: "currency", currency: "EUR" }).format(price);
}

export default PriceFormatter;
